export default __webpack_public_path__ + "static/media/graduado.b4dd1c2e.png";